var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('JsonExcel',{attrs:{"fetch":_vm.fetch,"fields":_vm.fieldsToExport,"worksheet":_vm.worksheetName,"name":_vm.fileName,"type":_vm.type}},[_vm._t("button",function(){return [_c('v-btn',{attrs:{"text":"","disabled":_vm.disable}},[_c('v-icon',[_vm._v(" mdi-microsoft-excel ")])],1)]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }